// viva_ui/src/Reports/EmployeeWiseReportTable.js
 
import React from 'react';
import { Box, IconButton, Stack } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import TableEmptyRow from '../shared/TableEmptyRow';
 
export const employeeWiseQueryBuilderColumns = [
  {
    field: 'name',
    label: 'Employee',
    type: 'string',
    operators: [
      { value: 'contains', key: 'Contains' },
      { value: 'equal', key: 'Equal' },
      { value: 'notequal', key: 'Not Equal' },
      { value: 'startswith', key: 'Starts With' },
      { value: 'endswith', key: 'Ends With' },
      { value: 'isempty', key: 'Is Empty' },
      { value: 'isnotempty', key: 'Is Not Empty' },
    ],
  },
  
  {
    field: 'employee_id',
    label: 'Employee ID',
    type: 'string',
    operators: [
      { value: 'contains', key: 'Contains' },
      { value: 'equal', key: 'Equal' },
      { value: 'notequal', key: 'Not Equal' },
      { value: 'startswith', key: 'Starts With' },
      { value: 'endswith', key: 'Ends With' },
    ],
  },
  {
    field: 'department',
    label: 'Department',
    type: 'string',
    operators: [
      { value: 'contains', key: 'Contains' },
      { value: 'equal', key: 'Equal' },
      { value: 'notequal', key: 'Not Equal' },
      { value: 'startswith', key: 'Starts With' },
      { value: 'endswith', key: 'Ends With' },
    ],
  },
  {
    field: 'pass_percent',
    label: 'Pass %',
    type: 'number',
    operators: [
      { value: 'equal', key: 'Equal' },
      { value: 'notequal', key: 'Not Equal' },
      { value: 'greaterthan', key: 'Greater Than' },
      { value: 'lessthan', key: 'Less Than' },
      { value: 'greaterthanorequal', key: 'Greater Than Or Equal' },
      { value: 'lessthanorequal', key: 'Less Than Or Equal' },
    ],
  },
  {
    field: 'exams_count',
    label: 'Exams',
    type: 'number',
    operators: [
      { value: 'equal', key: 'Equal' },
      { value: 'notequal', key: 'Not Equal' },
      { value: 'greaterthan', key: 'Greater Than' },
      { value: 'lessthan', key: 'Less Than' },
      { value: 'greaterthanorequal', key: 'Greater Than Or Equal' },
      { value: 'lessthanorequal', key: 'Less Than Or Equal' },
    ],
  },
];
 
const EmployeeWiseReportTable = ({
  reports = [],
  loading = false,
  page,
  setPage,
  pageSize,
  totalCount,
}) => {
  const navigate = useNavigate();
  const totalPages = Math.ceil(totalCount / pageSize);
 
  const renderPageNumbers = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else if (page <= 3) {
      pages.push(1, 2, 3, '...', totalPages);
    } else if (page >= totalPages - 2) {
      pages.push(1, '...', totalPages - 2, totalPages - 1, totalPages);
    } else {
      pages.push(1, '...', page - 1, page, page + 1, '...', totalPages);
    }
    return pages;
  };
 
  return (
    <>
      {loading ? (
        <div className="pd-table-loading">
          <div className="pd-table-loading-animation">
            <img
              className="pd-table-loading-video"
              src="/images/breath1.gif"
              alt="Loading reports..."
            />
            <p>Loading reports...</p>
          </div>
        </div>
      ) : (
        <>
          <div className={reports.length === 0 ? "" : "d-none d-md-block"} style={{ overflowX: "auto", scrollbarWidth: "thin", minHeight: "200px", maxHeight: '400px', borderRadius: '6px' }}>
            <table
              className="pd-table"
              style={{ tableLayout: "fixed", width: "100%" }}
            >
              <thead>
                <tr>
                  <th width="200px">Employee</th>
                  <th width="100px">Employee ID</th>
                  <th width="100px">Department</th>
                  <th width="100px">Pass Percentage</th>
                  <th width="100px">Exams</th>
                  <th width="150px">Actions</th>
                </tr>
              </thead>
              <tbody>
                {reports.length === 0 ? (
                  <TableEmptyRow colSpan={6} message="No reports found" />
                ) : reports.map((row) => (
                  <tr key={row.employee_guid || row.employee_id}>
                    <td>{row.name}</td>
                    <td>{row.employee_id}</td>
                    <td>{row.department}</td>
                    <td>
                      {row.pass_percent != null
                        ? `${Number(row.pass_percent).toFixed(2)}%`
                        : "-"}
                    </td>
                    <td>{row.exams_count}</td>
                    <td
                      style={{
                        verticalAlign: 'middle',
                        textAlign: 'left',
                        paddingLeft: '8px',
                      }}
                    >
                      <Stack
                        direction="row"
                        spacing={1}
                        alignItems="center"
                        justifyContent="flex-start"
                      >
                        <IconButton
                          size="small"
                          color="primary"
                          onClick={() => navigate(`/report/employee-courses?employeeGuid=${row.employee_guid}&employeePage=${page}`)}
                        >
                          <ArrowForward fontSize="small" />
                        </IconButton>
                      </Stack>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
 
          <div className={reports.length === 0 ? "d-none" : "d-md-none pr-1"} style={{ overflowX: "auto", scrollbarWidth: "thin", minHeight: "200px", maxHeight: '400px' }}>
            {reports.map((row) => (
              <div key={row.employee_guid || row.employee_id} className="card mb-3 glass-card border-0">
                <div className="card-body">
                  <h5 className="card-title d-flex justify-content-between">
                    {row.name}
                    <IconButton size="small" color="primary" onClick={() => navigate(`/report/employee-courses?employeeGuid=${row.employee_guid}&employeePage=${page}`)}>
                      <ArrowForward fontSize="small" />
                    </IconButton>
                  </h5>
                  <p className="mb-1"><strong>Employee ID:</strong> {row.employee_id}</p>
                  <p className="mb-1"><strong>Department:</strong> {row.department}</p>
                  <p className="mb-1"><strong>Exams:</strong> {row.exams_count}</p>
                  <p className="mb-0"><strong>Pass %:</strong> {Number(row.pass_percent).toFixed(2)}%</p>
                </div>
              </div>
            ))}
          </div>
 
          {reports.length > 0 && <Box className="pd-pagination">
            <button
              className="btn-negative"
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            >
              Previous
            </button>
 
            <div className="pd-page-numbers">
              {renderPageNumbers().map((pageNum, index) => (
                <button
                  key={index}
                  disabled={pageNum === "..."}
                  onClick={() =>
                    typeof pageNum === "number" && setPage(pageNum)
                  }
                  className={`pg-type-btn ${pageNum === page ? "active" : ""}`}
                >
                  {pageNum}
                </button>
              ))}
            </div>
 
            <button
              className="btn-negative"
              disabled={page === totalPages || totalCount === 0}
              onClick={() => setPage(page + 1)}
            >
              Next
            </button>
          </Box>}
        </>
      )}
    </>
  );
};
 
export default EmployeeWiseReportTable;
 
 
